import * as React from 'react';

let Routes = undefined as any;
try {
    Routes = require('../../../../src/Routes').default;
} catch (e) {
    // Dump
}

let ThemeMaterial = undefined as any;
try {
    ThemeMaterial = require('@mc/app-theme-material').default;
} catch (e) {
    // Dump
}
let ThemeBootstrap = undefined as any;
try {
    ThemeBootstrap = require('@mc/app-theme-bootstrap').default;
} catch (e) {
    // Dump
}

let LayoutComponent = 'div';

if (ThemeMaterial && ThemeBootstrap) {
    throw new Error('Both themes inside App');
} else {
    if (ThemeMaterial) {
        LayoutComponent = ThemeMaterial.Layout;
    } else if (ThemeBootstrap) {
        LayoutComponent = ThemeBootstrap.Layout;
    }
}

export class SkeletonLayout extends React.Component {
    componentDidMount() {
        if (!Routes) {
            console.error('No app router found');
        }
    }

    render() {
        return React.createElement(LayoutComponent, this.props, Routes !== undefined ? <Routes /> : undefined);
    }
}
